import React from 'react';
import toast from 'react-hot-toast';
import i18n from '../services/i18n';
import {isLogoutErrorVisible} from "../store/services/axios";
import {
    ErrorRounded
} from '@material-ui/icons';

export const showToast = (
    message?: string,
    backendErrorName?: string,
    exceptions?: string[],
) => {
    if(!isLogoutErrorVisible())
    {
        if (
            backendErrorName &&
            exceptions &&
            exceptions.find((a) => backendErrorName.includes(a || ''))
        ) {
            return;
        }

        // guard against non-string payloads (e.g. a caught AxiosError passed by mistake),
        // react-hot-toast would try to render them as a React child and crash the whole app
        const text = typeof message === 'string' ? message : undefined;

        if (text) {
            toast(text);
        } else {
            toast(i18n.t<string>('common:undefinedError'));
        }
    }
};

export const showErrorToast = (
    message: string,
) => {
    if(!isLogoutErrorVisible())
    {
        toast(message, {
            icon: (<ErrorRounded style={{ color: "#CB3632", fontSize: 24 }} />)
        });
    }
};
